import { useTranslator } from '@bluebeam/react-i18n';
import SingleSelect from 'components/inputs/dropdowns/SingleSelect';
import Immutable from 'immutable';
import React from 'react';
import { Priority } from 'records/Project';

interface Props {
  onChange: (value: string) => void;
  value: string;
  id: string;
  placeholder?: string;
  options: Immutable.Map<string, Priority>;
}

const PrioritySelect: React.FC<Props> = ({
  onChange,
  value,
  id,
  placeholder,
  options,
}) => {
  const { translate } = useTranslator(['punchesPage']);

  const handlePriorityChange = (evt: any): void => {
    onChange(evt.value);
  };

  const translatedOptions = options.map((priority) => {
    const priorityType: `${string}:${string}` =
      `punchesPage:priorities.${priority.value.toLowerCase()}` as `${string}:${string}`;
    priority.label = translate(priorityType);
    return priority;
  });

  return (
    <SingleSelect
      id={id}
      value={translatedOptions.get(value, {
        value: 'Normal',
        label: `${translate('punchesPage:priorities.normal')}`,
      })}
      options={Array.from(translatedOptions.values())}
      onChange={handlePriorityChange}
      placeholder={placeholder}
    />
  );
};

export default PrioritySelect;
